import { makeStyles } from '@material-ui/core/styles';
import { colors } from 'styles/colors';
import fonts from 'styles/fonts';
import spacing from 'styles/spacing';

const useStyles = makeStyles({
  formMessage: {
    fontSize: fonts.sizes.small,
    fontWeight: fonts.weights.normal,
    letterSpacing: '0.15px',
    lineHeight: '16px',
  },
  bodyContent: {
    flexGrow: 1,

    '& > div:first-child': {
      paddingBottom: '34px',
    },
    '& > div': {
      paddingBottom: '24px',
    },
    '& > div:last-child': {
      paddingBottom: '0',
    },
  },
  footer: {
    '& > button': {
      marginLeft: '6px',
    },
  },
  root: {
    '& .MuiInputAdornment-positionEnd > button': {
      color: colors.black,
    },
  },
  formLabel: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  formInput: {
    color: colors.black,
  },
  formBaseInput: {
    '& .MuiFormHelperText-root': {
      color: colors.gray,
    },
  },
  formInfoTitle: {
    fontSize: fonts.sizes.medium,
    fontWeight: fonts.weights.normal,
    letterSpacing: '0.15px',
    lineHeight: '24px',
  },
  formInfoValue: {
    fontSize: fonts.sizes.small,
    fontWeight: fonts.weights.medium,
    letterSpacing: '0.1px',
    lineHeight: '24px',
  },
  formInfoRow: {
    marginBottom: spacing.xxsmall,
  },
});

export default useStyles;
